/* Мидлвара добавляющая "/" в конце маршрута */
const IMAGE_REGEX = /\.(png|jpg|jpeg|svg|webp)$/i
const DUPLICATE_SLASHES_REGEX = /\/{2,}/g

export default defineNuxtRouteMiddleware(({ path, query, hash }) => {
  // Убираем лишние слэши, чтобы путь воспринимался внутренним для nuxt
  const normalizedPath = path.replace(DUPLICATE_SLASHES_REGEX, '/')

  if (IMAGE_REGEX.test(normalizedPath)) return

  let nextPath = normalizedPath

  if (normalizedPath !== '/' && !normalizedPath.endsWith('/')) {
    nextPath = `${normalizedPath}/`
  }

  if (nextPath === path) return

  return navigateTo({ path: nextPath, query, hash }, { redirectCode: 308 })
})
